import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { BaseChart, useHighcharts } from 'react-jsx-highcharts';

var HighchartsStockChart = function HighchartsStockChart(props) {
  var Highcharts = useHighcharts();
  return /*#__PURE__*/React.createElement(BaseChart, _extends({}, props, {
    chartCreationFunc: Highcharts.stockChart,
    chartType: "stockChart"
  }));
};

export default HighchartsStockChart;